export const SITE = {
  name: "MadlyDigital",
  tagline: "Empowering your Digital Dreams, Taking your Business Ahead.",
  description:
    "We design, build and scale category-defining digital products for ambitious teams.",
  email: "info@madlydigital.in",
  phone: "(+91) 90519 77553 / (+91) 87773 50068",
  address: "4/3 Kundu Lane, Bhowanipore, Kolkata – 700025, West Bengal, India",
  socials: [
    { label: "Twitter / X", href: "https://x.com" },
    { label: "LinkedIn", href: "https://linkedin.com" },
    { label: "Dribbble", href: "https://dribbble.com" },
    { label: "GitHub", href: "https://github.com" },
  ],
};

export const SERVICES = [
  {
    id: "Digital Marketing",
    title: "Digital Marketing",
    tagline: "Reach your audience.",
    description:
      "We use SEO, social media marketing, and performance campaigns to bring your product in front of the masses — increasing customers and brand visibility fast.",
    deliverables: ["Search Engine Optimization(SEO)", "Social Media Marketing(SMM)", "Paid  ad campaigns(Google/Meta)", "Performance analytics and reporting"],
    accent: "#2a979f",
  },
  {
    id: "brand-identity",
    title: "Branding & Brand Identity",
    tagline: "Build a brand that lasts.",
    description:
      "We shape how the world sees your business — from your logo to your tone of voice — building a brand that stands out and lasts for years.",
    deliverables: ["Logo design & Brand Mark", "Brand stle guide (Colors & Fonts)", "Brand voice & messaging strategy", "Marketing collateral design"],
    accent: "#FF3366",
  },
  {
    id: "Web Design & Development",
    title: "Web Design & Development",
    tagline: "Build to last and make an impact.",
    description:
      "Our team of creative designers and skilled developers build attractive, fast, and functional websites that convert visitors into customers.",
    deliverables: ["UI/UX design & prototyping", "Responsive website development", "CMS integration (WordPress etc.)", "SEO-ready, speed-optimized launch"],
    accent: "#A78BFA",
  },
  {
    id: "Photography & Videography",
    title: "Photography & Videography",
    tagline: "Capture the moment, tell the story.",
    description:
      "High-quality visual content that brings your brand to life and connects with your audience on a deeper level.",
    deliverables: ["Product photography", "Event videography", "Brand storytelling", "Post-production editing"],
    accent: "#F59E0B",
  },
  {
    id: "Creative Design",
    title: "Creative Design",
    tagline: "Design with purpose & Ideas Made Visual.",
    description:
      "From posters to packaging, our creative design team brings the visual soul of your brand to life with imagination and strategic intent.",
    deliverables: ["Poster & banner design", "Brochure, flyer & print design", "Packaging & product label design", "Social media creatives & templates"],
    accent: "#3473d3",
  },
  {
    id: "Motion Graphics",
    title: "Motion Graphics",
    tagline: "Bring your ideas to life.",
    description:
      "We give movement to your brand story through animated visuals that grab attention faster than any static design ever could.",
    deliverables: ["Animated logo & brand intro", "Explainer & promo animations", "Social media animated posts", "Infographic motion videos"],
    accent: "#ba1758",
  },
  {
    id: "Events & Exhibition",
    title: "Events & Exhibition",
    tagline: "Beyond the screen.",
    description:
      "We help your brand step into the real world — planning and managing events and exhibitions that create genuine connections with your audience.",
    deliverables: ["Event planning & coordination", "Exhibition design & setup", "Brand activation experiences", "Post-event analysis & reporting"],
    accent: "#FBBF24",
  },
  // {
  //   id: "growth-systems",
  //   title: "Growth Systems",
  //   tagline: "Compound momentum.",
  //   description:
  //     "Experimentation platforms, analytics stacks and lifecycle programs that turn insight into revenue loops.",
  //   deliverables: ["Analytics & attribution", "A/B experimentation", "Lifecycle & CRM", "Conversion optimization"],
  //   accent: "#F472B6",
  // },
];

export const STATS = [
  { value: "50+", label: "Clients served" },
  { value: "7", label: "Core Services" },
  { value: "100+", label: "Projects delivered" },
  { value: "4.9", label: "Avg. client rating" },
];

export const CLIENTS = [
  "Lumen", "Kairos", "Helix", "Northwind", "Orbital",
  "Paragon", "Vanta", "Meridian", "Aperture", "Monolith",
];

export const VALUES = [
  {
    title: "Creativity is a strategy",
    body: "We treat every brief as a creative challenge. Design decisions aren't decorative — they drive business outcomes.",
  },
  {
    title: "Small teams, sharp focus",
    body: "We work in lean, focused pods. No unnecessary layers, no lost briefs. Just sharp people close to the problem.",
  },
  {
    title: "Transparency over talk",
    body: "We communicate openly at every step. You always know what's happening, why it's happening, and what's next.",
  },
  {
    title: "Partners, not vendors",
    body: "We care about the outcome more than the invoice. We say no to work where we can't genuinely move the needle.",
  },
];

export const WORKS = [
  {
    id: "hl-book-design",
    title: "Therapeutics Catalog",
    client: "HL",
    year: "2022",
    category: "Book Design",
    tags: ["Book Design", "Print"],
    img: "/works/Book-design-500x500.jpg",
    accent: "#0EA5E9",
    featured: true,
    description:
      "A comprehensive product catalog for HL's range of tonics, malts, and drops — designed to educate and convert medical professionals.",
  },
  {
    id: "bienestar-visiting-card",
    title: "Brand Identity & Visiting Card",
    client: "Bienestar Life Science",
    year: "2021",
    category: "Visiting Card",
    tags: ["Visiting Card", "Logo"],
    img: "/works/Visiting-Card-500x500.jpg",
    accent: "#B45309",
    featured: true,
    description:
      "A warm, natural brand identity for a life science company, featuring a distinctive mascot logo and elegant visiting card design.",
  },
  {
    id: "nmist-sanitizer",
    title: "Sanitizer Product Range",
    client: "Nmist",
    year: "2021",
    category: "Packaging",
    tags: ["Packaging", "Product Design"],
    img: "/works/Mist-Inn-500x500.jpg",
    accent: "#2563EB",
    featured: true,
    description:
      "Clean and clinical packaging design for a full range of hand sanitizer and disinfectant spray products.",
  },
  {
    id: "nimitol-packaging",
    title: "Nimitol Product Label",
    client: "Nimitol",
    year: "2022",
    category: "Packaging",
    tags: ["Packaging", "Label Design"],
    img: "/works/Nimitol-500x500.jpg",
    accent: "#10B981",
    featured: false,
    description:
      "Refreshing, nature-inspired packaging for a mint-based personal care product.",
  },
  {
    id: "nmist-box-packaging",
    title: "Nmist Box Packaging",
    client: "Nmist",
    year: "2022",
    category: "Packaging",
    tags: ["Packaging", "Print"],
    img: "/works/Nano-Mist-500x500.jpg",
    accent: "#E11D48",
    featured: false,
    description:
      "Bold, clinical box packaging design for Nmist's premium sanitizer product line.",
  },
  {
    id: "olivol-body-oil",
    title: "Olivol Body Oil",
    client: "JRC",
    year: "2023",
    category: "Packaging",
    tags: ["Packaging", "Label Design"],
    img: "/works/Jac-Olivol-Body-Oil-500x500.jpg",
    accent: "#D97706",
    featured: true,
    description:
      "Mediterranean-inspired packaging for JRC's Olivol Body Oil — communicating naturalness and premium quality.",
  },
  {
    id: "hrms-web-app",
    title: "HR Management System",
    client: "Madly Digital",
    year: "2025",
    category: "Web & App",
    tags: ["Web & App", "UI/UX", "Development"],
    img: "/works/Web-Design-Development-720x717.webp",
    accent: "#7C3AED",
    featured: true,
    description:
      "A full-stack Human Resource Management System — featuring employee profiles, attendance, payroll, leave management, and AI-powered face recognition.",
  },
  {
    id: "Photography & Videography",
    title: "Photography & Videography",
    client: "Groomed",
    year: "2022",
    category: "Photography & Videography",
    tags: ["Photography & Videography", "Branding"],
    img: "/works/Photography-Videography-720x717.webp",
    accent: "#9F1239",
    featured: false,
    description:
      "A playful yet refined brand identity for a grooming brand, anchored by a distinctive mascot character.",
  },
];
